import BasePolicy from '@/policies/BasePolicy.js';

export default class RemediationPolicy extends BasePolicy {
    viewAny(user) {
        return (
            user.hasPermissionTo('view all remediation processes') ||
            user.hasGroupPermissionTo('view all remediation processes')
        );
    }

    create(user) {
        if (user.hasGroupPermissionTo('create a remediation process')) {
            return false;
        }

        return user.hasPermissionTo('create a remediation process');
    }
}
